import { gql } from "@apollo/client";
import { useResettableMutation } from "../useResettableMutation";
import { getErrors } from "../../utils/apolloError";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { DeleteRegisterAssignment, DeleteRegisterAssignmentVariables } from "./__generated__/DeleteRegisterAssignment";

const DELETE_REGISTER_ASSIGNMENT = gql`
  mutation DeleteRegisterAssignment($permitRegisterId: String!, $registerAssignmentId: String!) {
    deleteRegisterAssignment(input: { permitRegisterId: $permitRegisterId, registerAssignmentId: $registerAssignmentId }) {
      deletedRegisterAssignmentId
    }
  }
`;

export function useDeleteRegisterAssignment() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    DeleteRegisterAssignment,
    DeleteRegisterAssignmentVariables
  >(DELETE_REGISTER_ASSIGNMENT, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
